module.exports = __webpack_public_path__ + "static/media/nouvelr-regular.b1bbeef5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/nouvelr/nouvelr-regular.ttf
// module id = 936
// module chunks = 0